import React from 'react';
import { Link } from 'gatsby';
import articleBoxStyles from './ArticleBox.module.scss';

export default function ArticleBox({
	title,
	excerpt,
	imageURL,
	date,
	url,
	category,
}) {
	return (
		<Link
			to={url}
			className={
				'overflow-hidden shadow-sm mt-4 mb-1 rounded d-flex flex-md-row bg-white w-100 ' +
				articleBoxStyles.box
			}
		>
			<div className='col-4 px-0'>
				<img
					src={imageURL}
					alt='...'
					className={'img-fit ' + articleBoxStyles.img100}
				/>
			</div>
			<div className='col-8 p-3 pb-2 d-flex flex-column'>
				<h4 className='mb-2'>{title}</h4>
				<p className={'flex-grow-1 mb-1 ' + articleBoxStyles.text}>{excerpt}</p>
				<p className='card-text align-self-end'>
					<small className='text-muted'>
						{category} - {date}
					</small>
				</p>
			</div>
		</Link>
	);
}
